export const SEND_CODE_FAILED_MESSAGE = "Не удалось отправить код. Обратитесь в тех. поддержку";

// Русские сообщения бэка (лимиты SMS, «Не удалось отправить код…») показываем
// как есть — они уже написаны для человека. Всё остальное (сеть, английские
// технические ответы) — общим текстом со ссылкой на поддержку, а не молчанием.
export const getSendCodeErrorMessage = (message: unknown): string =>
  typeof message === "string" && /[а-яё]/i.test(message) ? message : SEND_CODE_FAILED_MESSAGE;
